export default __webpack_public_path__ + "fe7753cf2e6396e69af3d4d62fb15b25.png";